import { TooltipText } from 'components/shared/TooltipText';
import React from 'react';
import { empty } from '../JsonFrame';
import { JsonContentValidationMessage } from './JsonContentValidationMessage';

interface HeaderTypeProps {
  val: string;
  isZoomInActive?: boolean;
}

export const HeaderType: React.FunctionComponent<HeaderTypeProps> = (props): JSX.Element => {
  const headerMessageClass = 'wordBreak pl-3 pr-3';
  return !empty(props.val) ? (
    <h5 className={headerMessageClass}>{props.val}</h5>
  ) : (
    <JsonContentValidationMessage
      message={TooltipText.headerTypeValidationMessage}
      validationMessageWrapperClass={'mb-2 ' + headerMessageClass}
    />
  );
};
